var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "m21.85 20.94-5.77-5.71c1.25-1.41 2.02-3.25 2.02-5.26 0-4.4-3.61-7.97-8.05-7.97S2 5.58 2 9.97s3.61 7.97 8.05 7.97c2.04 0 3.9-.76 5.32-2l5.78 5.71c.1.1.22.14.35.14s.26-.05.36-.15c.19-.2.19-.51 0-.71zM3 9.97C3 6.13 6.16 3 10.05 3s7.05 3.13 7.05 6.97-3.16 6.97-7.05 6.97S3 13.81 3 9.97"
})));
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYjMxNDBmZjc5NTdjNjMxODliZWEwNTQ5ZWY1ZWYxM2Quc3ZnIjs=";